module.exports = __webpack_public_path__ + "static/media/thumbnail.d53166be.jpg";